<div *ngIf="tooltipData" class="custom-tooltip">
  <span [innerHTML]="tooltipData"></span>
</div>
